export const handleClickFrequentlyAskedQuestionLink = ({
  value,
  url,
  trackingSource
}) => {
  console.log({
    value,
    url,
    type: 'external',
    trackingSource
  });
};